module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('md-card', [_c('md-card-content', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("admin.current")))]), _vm._v(" "), _c('span', [_vm._v("Új funkció a rendszerben: napi bontás a páciensek adatlapján."), _c('br'), _vm._v(_vm._s(_vm.$t("admin.consultinghours")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("admin.nextoverall")))]), _vm._v(" "), (_vm.globalInfo.hasNextConsulting) ? _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.globalInfo.nextConsultingDate) + " (páciensek adatai alapján)\n\t\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("admin.novisit")) + "\n\t\t\t\t")])])])], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.totalizedsymptoms")))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.$t("admin.allpatients")))])]), _vm._v(" "), _c('md-card-content', [_c('line-chart', {
    attrs: {
      "values": _vm.globalSymptoms
    }
  })], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.filledinspector")))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.$t("admin.allpatients")))])]), _vm._v(" "), _c('md-card-content', [_c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-progress": _vm.controlProgress()
    }
  }), _vm._v(" "), (_vm.globalInfo.filledControl > 0) ? _c('p', [_vm._v(_vm._s(_vm.globalInfo.patientCount) + " páciensből " + _vm._s(_vm.globalInfo.filledControl) + " töltötte ki az állapotfelmérőt")]) : _c('p', [_vm._v(_vm._s(_vm.$t("admin.noinspector")))])], 1), _vm._v(" "), _c('md-card-actions')], 1), _vm._v(" "), _c('md-table-card', [_c('md-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.newpatients")))])]), _vm._v(" "), _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.numberofsymptoms")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.data")))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.newPatients), function(patient, index) {
    return _c('md-table-row', {
      key: index,
      attrs: {
        "md-item": patient
      }
    }, [_c('md-table-cell', {
      key: 'name',
      attrs: {
        "md-numeric": false
      }
    }, [_vm._v(_vm._s(patient.name ? patient.name : "Nincs név megadva"))]), _vm._v(" "), _c('md-table-cell', {
      key: 'email',
      attrs: {
        "md-numeric": false
      }
    }, [_vm._v(_vm._s(patient.email))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(patient.symptomCount))]), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
      staticClass: "md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.showPatient(patient)
        }
      }
    }, [_vm._v("Adatok")])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Levegő minőség jelentések")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\tPollen:\n\t\t\t"), _c('a', {
    staticClass: "md-padding",
    attrs: {
      "href": "http://oki.antsz.hu/files/jelentesek/aktualis.pdf",
      "target": "_blank"
    }
  }, [_vm._v("ANTSZ")]), _vm._v(" "), _c('a', {
    staticClass: "md-padding",
    attrs: {
      "href": "http://www.met.hu/idojaras/humanmeteorologia/pollenjelentes/",
      "target": "_blank"
    }
  }, [_vm._v("MET")]), _vm._v(" "), _c('a', {
    staticClass: "md-padding",
    attrs: {
      "href": "https://www.idokep.hu/pollen",
      "target": "_blank"
    }
  }, [_vm._v("Időkép pollen")]), _vm._v("\n\t\t\tLégszennyezettség:\n\t\t\t"), _c('a', {
    staticClass: "md-padding",
    attrs: {
      "href": "https://www.idokep.hu/szmog",
      "target": "_blank"
    }
  }, [_vm._v("Időkép szmog")]), _vm._v(" "), _c('a', {
    staticClass: "md-padding",
    attrs: {
      "href": "http://www.legszennyezes.hu",
      "target": "_blank"
    }
  }, [_vm._v("Légszennyezés.hu")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cb0271f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Dashboard.vue
// module id = 415
// module chunks = 2